import React from 'react';
import { Panel as RPanel } from 'react-bootstrap';
import styled from 'styled-components';

const MarginBelow = styled.div`
  margin-bottom: 5em;
`;

const Panel = styled(RPanel)`
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

const PagePanel = props => (
  <MarginBelow>
    <Panel>
      {props.children}
    </Panel>
  </MarginBelow>
);


export default PagePanel;



// WEBPACK FOOTER //
// ./src/components/PagePanel.js